export default __webpack_public_path__ + "static/media/tenure-icon-05.836087b2.png";